// eslint-disable-next-line
import React, { ReactNode } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import styles from './Routing.module.scss';
import { connect } from 'react-redux';
import { State } from 'history';
import _ from 'lodash';

type RoutingProp = {
    routing?: boolean;
    children?: ReactNode;
};

const Routing: React.FC<RoutingProp> = ({ routing }) => {
    let className = `${styles['routing']} `;
    if (!routing) {
        className += `${styles['hidden']} `;
    }
    return (
        <div className={className}>
            <LinearProgress color="secondary" />
        </div>
    );
};

function mapStateToProps(state: State) {
    return {
        routing: _.get(state, 'Routing.routing'),
    };
}

export default connect(mapStateToProps)(Routing);
